<template>
  <a-video-banner
    :video-banner-type="$options.consts.VIDEO_BANNER_TYPE.ARTICLE"
    class="article__video-banner"
    :layout="layout"
  />
</template>

<script>
import AVideoBanner from 'shared/AVideoBanner'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { VIDEO_BANNER_TYPE } from 'enums/video-banner'

export default {
  name: 'ArticleVideoBanner',
  components: { AVideoBanner },
  props: {
    layout: propValidator([PROP_TYPES.STRING], false, null)
  },
  consts: {
    VIDEO_BANNER_TYPE
  }
}
</script>

<style lang="scss">
.article__video-banner {
  .primisslate {
    display: flex;
    max-width: $article-sidebar-width - 2 * 15px; // Sidebar width - paddings
    margin: 0 auto;

    @include mobile {
      max-width: 100%;
    }
  }
}

.global-wrapper.preview-mode .article__video-banner.video-banner__wrapper {
  height: 244px;
}
</style>
